import { useNavigate } from 'react-router';

const useNavigateWithQueryParams = () => {
  const navigate = useNavigate();

  const navigateWithQueryParams = (route: string, paramKeys: string[]) => {
    const searchParams = new URLSearchParams(window.location.search);
    const filteredParams = new URLSearchParams();

    for (const key of paramKeys) {
      const value = searchParams.get(key);
      if (value !== null) {
        filteredParams.set(key, value);
      }
    }

    const filteredParamsStr = filteredParams.toString();

    if (!filteredParamsStr) {
      navigate(route);
      return;
    }

    if (route.includes('?')) {
      navigate(`${route}&${filteredParamsStr}`);
      return;
    }

    navigate(`${route}?${filteredParamsStr}`);
  };

  return navigateWithQueryParams;
};

export default useNavigateWithQueryParams;
